import { DropdownFoldMenu } from '#/components/Dropdown/menus/Fold/DropdownFoldMenu';
import { useI18n } from '#/i18n/hooks/useI18n';
import { volunteerDropdownDataByLocale } from '#/mappings/VolunteerDropdown/volunteerDropdownDataByLocale';

import {
  volunteerDropdownDataByResourcesItemType,
  volunteerDropdownDataBySearchItemType,
} from './volunteerDropdownConstants';

type Props = {
  trackClickedContext: string;
};

export function VolunteerDropdownMenu({ trackClickedContext }: Props) {
  const { locale } = useI18n();
  const { search, resources } = volunteerDropdownDataByLocale[locale];

  return (
    <DropdownFoldMenu
      left={{
        title: search.title,
        width: 260,
        items: search.items.map((searchItem) => {
          const { iconName, qaId, trackClickedName } =
            volunteerDropdownDataBySearchItemType[searchItem.type];

          return {
            iconName,
            title: searchItem.title,
            href: searchItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
      right={{
        title: resources.title,
        items: resources.items.map((resourceItem) => {
          const { image, imageHover, qaId, trackClickedName } =
            volunteerDropdownDataByResourcesItemType[resourceItem.type];

          return {
            image,
            imageHover,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
    />
  );
}
